export default __webpack_public_path__ + "gittip-website-logo.png";